import React from 'react'

import { Box, Chip, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'

import { SectionPanel } from 'components/_base'

type Props = {
  title: string
  icon: React.ReactNode
  color: string
  count: number
  overridden?: number
  differing?: number
  open: boolean
  onToggle: () => void
  children: React.ReactNode
}

// One panel per group. The table lives inside it, so each panel sizes its own columns and the grid
// can put two side by side without the six columns having to agree across the whole screen.
const CustomerFeaturePanel = ({
  title,
  icon,
  color,
  count,
  overridden,
  differing,
  open,
  onToggle,
  children,
}: Props) => (
  <SectionPanel
    adornments={
      <>
        {/* The same two colours the rows use, so a heading and the rows under it agree. */}
        {!!differing && (
          <Chip color="info" component="span" label={`${differing} differ from plan`} size="small" variant="outlined" />
        )}

        {!!overridden && (
          <Chip color="primary" component="span" label={`${overridden} overridden`} size="small" variant="outlined" />
        )}

        <Box component="span" sx={{ color: 'text.secondary', fontVariantNumeric: 'tabular-nums' }}>
          {count}
        </Box>
      </>
    }
    color={color}
    icon={icon}
    onToggle={onToggle}
    open={open}
    title={title}>
    <Table size="small" sx={{ tableLayout: 'fixed', width: '100%', '& td': { borderColor: 'divider' } }}>
      <TableHead>
        <TableRow>
          {/* The value column has to hold its field plus the inherit button, and the usage column
                its bar - which is what sets the width a panel needs before two of them are worth it. */}
          <TableCell sx={{ pl: 2, width: '24%' }}>Feature</TableCell>
          <TableCell sx={{ width: '22%' }}>This customer</TableCell>
          <TableCell sx={{ width: '9%' }}>Plan</TableCell>
          <TableCell sx={{ width: '18%' }}>Used this month</TableCell>
          <TableCell sx={{ width: '22%' }}>Who set it</TableCell>
          <TableCell sx={{ width: '5%' }} />
        </TableRow>
      </TableHead>

      <TableBody>{children}</TableBody>
    </Table>
  </SectionPanel>
)

export default CustomerFeaturePanel
